import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/countries';

export const initialState = resourceState;

export default resourceReducerFactory(initialState, types);
